import React from 'react';
import { WeekSelectionWrapper, TotalGrossContainer } from './weeklyReports';
import styles from './reports.module.scss';
import * as XLSX from "xlsx";
import {
    DISPATCH_LOAD_COLUMNS,
    DISPATCH_PERFORMANCE_LOADS_KEY,
    getVisibleReportColumns,
    resolveVisibleCatalog,
} from './reportColumnSettings';
import { ReportLoadSubContent, getReportLoadExportValue } from './reportSubContent';

export const WeeklyGrossByDispatcher = ({companyData, department}) => {
    const headerObject = ["Dispatcher", "Total Gross"];
    return <WeekSelectionWrapper
        companyData={companyData}
        reportLink={'loads/bookedByReport'}
        rowType={"clickable"}
        headerObject={headerObject}
        custoMreportClass={BookedByReport}
        rowFunction={DispatchRowReport}
        SubContentPart={ReportLoadSubContent}
        subcontentArrayName={"loads"}
        exportToXlsx={exportDispatcherReportToXlsx}
        startWithPrevWeek={true}
        department={department}
        columnSettings={{
            reportKey: DISPATCH_PERFORMANCE_LOADS_KEY,
            catalog: DISPATCH_LOAD_COLUMNS,
        }}
    />
}
class BookedByReport{
    dispatcherName;
    totalGross;
    constructor(report){
        this.dispatcherName = report.bookedBy;
        this.totalGross = report.totalGross;
    }
}
const DispatchRowReport = (key, singleReport, currentReport, selectedPeriod, setCurrentReport, department ) => {
     
    if(key === "totalGross"){
        return <div key={key} className={`${styles.hasCustomColor} ${styles.lastChild}`}><TotalGrossContainer  totalGross={singleReport.totalGross} /></div>
    }
    return <div key={key} className={styles[key]} >{singleReport[key]}</div>;
}
async function exportDispatcherReportToXlsx(metadata, data) {
    try {
      let filename = `Dispatcher Performance Report ${metadata.fileName.replace(/\//g, '.')}`;
      if(metadata.timeframe === 'monthly'){
          filename += ` ${metadata.startDate.slice(0, 4)}`;
      }
      filename += '.xlsx';

      const catalog = metadata.catalog || DISPATCH_LOAD_COLUMNS;
      const visibleKeys = Array.isArray(metadata.visibleColumns) && metadata.visibleColumns.length
        ? metadata.visibleColumns
        : getVisibleReportColumns(DISPATCH_PERFORMANCE_LOADS_KEY, catalog);
      const loadColumns = resolveVisibleCatalog(visibleKeys, catalog);
      const headers = ["Dispatcher", ...loadColumns.map((col) => col.label), "Total Gross"];
      const lastCol = headers.length - 1;
  
      const aoa = [headers];
      const merges = [];
      let currentRow = 1;
  
      for (const group of data ?? []) {
        const loads = Array.isArray(group.loads) && group.loads.length ? group.loads : [{}];
        const startRow = currentRow;
        for (const ld of loads) {
          aoa.push([
            group.bookedBy ?? "",
            ...loadColumns.map((col) => getReportLoadExportValue(ld, col)),
            "",
          ]);
          currentRow++;
        }
  
        aoa[startRow][0] = group.bookedBy ?? "";
        aoa[startRow][lastCol] = Number(group.totalGross) || 0;
  
        const endRow = currentRow - 1;
        if (endRow > startRow) {
          merges.push(
            { s: { r: startRow, c: 0 }, e: { r: endRow, c: 0 } },
            { s: { r: startRow, c: lastCol }, e: { r: endRow, c: lastCol } }
          );
        }
      }
  
      const ws = XLSX.utils.aoa_to_sheet(aoa);
      ws["!merges"] = merges;
      ws["!cols"] = [
        { wch: 22 },
        ...loadColumns.map((col) => ({
          wch: col.type === 'location' ? 36 : col.type === 'driverPayout' || col.type === 'text' ? 24 : 16,
        })),
        { wch: 16 },
      ];

      const lastRow = aoa.length;
      const moneyCols = new Set();
      loadColumns.forEach((col, index) => {
        if (col.type === 'money' || col.type === 'rpm') moneyCols.add(index + 1);
      });
      moneyCols.add(lastCol);

      for (let r = 2; r <= lastRow; r++) {
        for (const c of moneyCols) {
          const ref = XLSX.utils.encode_cell({ r: r - 1, c });
          if (ws[ref] && typeof ws[ref].v === "number") {
            ws[ref].t = "n";
            ws[ref].z = "#,##0.00";
          }
        }
      }
  
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Dispatcher Report");
  
      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const blob = new Blob([wbout], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
  
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      await new Promise((res) => setTimeout(res, 100));
      URL.revokeObjectURL(url);
  
      return true;
    } catch (err) {
      console.error("Failed to export dispatcher XLSX:", err);
      return false;
    }
  }
